export default __webpack_public_path__ + "static/media/phone-inactive.be06c267.svg";